/** Use the reader's browser locale and time zone, including daylight saving. */
export const messageTimestamp = (createdAt?: string): string | undefined => {
  if (!createdAt) return undefined;
  const date = new Date(createdAt);
  if (!Number.isFinite(date.getTime())) return undefined;
  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
};
